export default "__VITE_ASSET__1e2444da__"